import React from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import { Head } from '@/components/_common';
import { useLoginStates } from '@/hooks';

import { Props } from '../job-metadata';

const MetadataComponent: React.FC<Props & WrappedComponentProps> = ({ job, intl }) => {
  const { isLoggedOut } = useLoginStates();
  const company = job.companyInfo?.company;

  const title = `${intl.formatMessage(
    { id: isLoggedOut ? 'JOB_SEO_TITLE_TAG_POSTING_DETAIL' : 'JOB_TITLE_TAG_SHOW_POSTING_DETAIL' },
    { job_title: job.title, work_location: job.location?.city }
  )} | ${intl.formatMessage({ id: 'JOB_TITLEBAR_SUFFIX' })}`;

  const metaTitle = `${job.title} | ${intl.formatMessage({ id: 'JOB_TITLEBAR_SUFFIX' })}`;

  const metaDescription = intl.formatMessage(
    { id: 'JOB_SEO_META_DESCRIPTION_TAG_POSTING_DETAIL_TEMP' },
    {
      function: job.title,
      company_name: job.companyInfo?.companyNameOverride ?? company?.name,
      city: job.location?.city,
      industry: job.industry?.title,
      job_type: job.employmentType?.type,
      level: job.careerLevel?.level,
      date: intl.formatDate(job.date ?? '', { year: 'numeric', month: 'short', day: 'numeric' }),
    }
  );

  return (
    <Head
      title={title}
      ogTitle={metaTitle}
      canonicalUrl={job.url}
      description={metaDescription}
      image={company?.logo?.urlMeta}
      keywords={job.keywords.toString()}
      robots="index, follow"
    />
  );
};

export const Metadata = injectIntl(MetadataComponent);
